module.exports = __webpack_public_path__ + "static/media/nina.c97b88d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profiles/nina.png
// module id = 927
// module chunks = 0